import request from "@/service/invites";
export default {
  name: "TextMasker",
  props: {
    mask: {
      type: String,
      default: ""
    },
    detailId: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "mobile"
    }
  },
  data() {
    return {
      maskValue: false,
      decrypText: ""
    };
  },
  computed: {
    maskMap() {
      return {
        false: {
          type: "text",
          icon: "ios-eye-off-outline",
          text: this.mask
        },
        true: {
          type: "password",
          icon: "ios-eye-outline",
          text: this.decrypText
        }
      };
    },
    masker() {
      return this.maskMap[this.maskValue];
    }
  },
  watch: {
    maskValue: {
      handler(newVal) {
        if (newVal) {
          this.decryptMaskText();
        }
      },
      immediate: false
    }
  },
  methods: {
    changeEye() {
      this.maskValue = !this.maskValue;
    },
    async decryptMaskText() {
      let {
        result,
        retVal
      } = await request.decryptMask({
        detailId: this.detailId
      });
      if (result === 0) {
        this.decrypText = retVal[this.type];
      }
    }
  }
};